import { AlertTriangle, CheckCircle2, Circle, Loader2 } from 'lucide-react';

import type { SessionStage } from './session-stage';

const LOOK: Record<SessionStage, { className: string; icon: React.ReactNode }> =
  {
    failed: {
      className: 'bg-tag-critical text-critical',
      icon: <AlertTriangle aria-hidden="true" className="size-3" />,
    },
    live: {
      className: 'bg-tag-major text-tag-major-ink',
      icon: (
        <span aria-hidden="true" className="relative flex size-2">
          <span className="absolute inline-flex size-full animate-ping rounded-pill bg-warning opacity-60 motion-reduce:animate-none" />
          <span className="relative inline-flex size-2 rounded-pill bg-warning" />
        </span>
      ),
    },
    new: {
      className: 'bg-tag-minor text-text-secondary',
      icon: <Circle aria-hidden="true" className="size-3" />,
    },
    ready: {
      className: 'bg-tag-success text-success-ink',
      icon: <CheckCircle2 aria-hidden="true" className="size-3" />,
    },
    writing: {
      className: 'bg-info-soft text-info',
      icon: (
        <Loader2
          aria-hidden="true"
          className="size-3 animate-spin motion-reduce:animate-none"
        />
      ),
    },
  };

/** A session's stage as a small coloured pill. */
export function StagePill({
  label,
  stage,
}: {
  label: string;
  stage: SessionStage;
}) {
  const look = LOOK[stage];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-pill px-2 py-0.5 text-tag font-semibold ${look.className}`}
    >
      {look.icon}
      {label}
    </span>
  );
}
